import React, { useState, useEffect, useMemo, useCallback } from "react"
import {
  get,
  size,
  forEach,
  map,
  merge,
  isEmpty,
  chunk,
  clone,
  includes,
  pull,
  find,
  isNil,
} from "lodash"
import ClassNames from "classnames"
import { Modal, OverlayTrigger, Popover } from "react-bootstrap"
import { BaseSelect } from "components/atoms/input/select"
import * as Formatter from "utils/Formatter"
import { Panel } from "./index"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import {
  NewsListContents,
  SpNewsListContents,
  SymbolDetailMoalNewsListContents,
} from "components/molecules/list/news"
import { Pagination } from "components/molecules/pagination"
import {
  ToggleFilter,
  SpToggleFilter,
} from "components/molecules/filter/toggleFilter"
import { newsQueryString } from "utils/util"
import store from "redux/store"
import { SearchDetail } from "components/utils/search"
import { Tab } from "components/atoms/btn/tab"
import { NEWS_TOGGLE, PAGE_NUM } from "config/const"
import { checkIsSp, open_symbol_detail } from "utils/util"
import uuid from "uuid"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { useEffectFirstSkip } from "components/actions/customHook/useEffectFirstSkip"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"
import { showSymbol } from "redux/ducks/SymbolDetail"

type Props = {
  title?: string
  delete?: Function
  isNewsTab?: boolean
  route?: number
  symbol?: object
  tabItem?: {
    tabList: Array<{
      id: number | string
      name: string
    }>
    activeTab: number
    changeTab: Function
  }
  effect?: boolean
  setEffect?: Function
  hiddenRefresh?: boolean
}

type ModalProps = {
  show: boolean
  onHide: () => void
  data: object
}

export const NewsModal = (props: ModalProps) => {
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const [showNewsSymbol, setShowNewsSymbol] = useState(false)
  // const [showMoreButton, setShoeMoreButton] = useState(false)
  const relatedSymbols: Array<object> = get(props.data, "RelatedSymbolList")

  useEffect(() => {
    if (props.show) {
      const newsAreaSize = document.getElementById("newsArea")
      if (!newsAreaSize) return
      if (newsAreaSize.clientHeight > 24) {
        setShowNewsSymbol(true)
      }
    } else {
      setShowNewsSymbol(false)
    }
  }, [props.show])
  return (
    <Modal
      {...props}
      size="xl"
      className={ClassNames({ "sp-news-modal": isPhone })}
    >
      <Modal.Header className="modal-news">
        <div className="header-title">
          <div className="news-title">{get(props.data, "Title")}</div>
          <div className="modal-date">
            {Formatter.date(get(props.data, "UpdTime"), "YYYY/MM/DD HH:mm")}{" "}
          </div>
        </div>
        {!isPhone && (
          <div className="header-nav-icon-col">
            <div
              className="header-icon ripple"
              data-izimodal-close
              onClick={props.onHide}
            >
              <i className="material-icons">close</i>
            </div>
          </div>
        )}
      </Modal.Header>
      <Modal.Body>
        <div className="modal-body-news-content">
          <div className="scroll-block modal-news-block">
            <div className="news-contents-group">
              <p className="news-cont">{get(props.data, "Content")}</p>
            </div>
          </div>
        </div>
        {!!relatedSymbols && relatedSymbols.length > 0 && (
          <div
            className={ClassNames({
              "news-area": true,
              "news-symbol": showNewsSymbol,
            })}
            id="newsArea"
          >
            {map(relatedSymbols, (symbol: object) => {
              return (
                <span
                  className="btn btn-primary btn-shaped btn-relative btn-news"
                  onClick={() => {
                    !isPhone
                      ? open_symbol_detail(symbol)
                      : store.dispatch(showSymbol(symbol))
                    props.onHide()
                  }}
                >
                  {get(symbol, "SymbolNameS")}
                </span>
              )
            })}
          </div>
        )}
        {!!relatedSymbols && relatedSymbols.length > 0 && showNewsSymbol && (
          <>
            <div
              className="btn btn-primary btn-shaped btn-news-symbol-more"
              onClick={() => setShowNewsSymbol(false)}
            >
              もっと見る
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-bottom-btn-row">
          <div
            className="btn btn-outline ripple"
            data-izimodal-close
            onClick={props.onHide}
          >
            閉じる
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export const NewsDetailContents = (props: {
  data: object
  textColor?: string
  list: object
}) => {
  const { data, textColor, list } = props
  const relatedSymbolList = get(data, "RelatedSymbolList")
  return (
    <div className="news-detail-contents">
      <div
        className={ClassNames({
          "text-color-white": textColor === "white",
          "text-color-ivory": textColor === "ivory",
          "text-color-cream": textColor === "cream",
          "text-color-yellow": textColor === "yellow",
          "text-color-gray": textColor === "gray",
          "text-color-navy": textColor === "navy",
          "text-color-black": textColor === "black",
        })}
      >
        {isEmpty(list) ? "" : get(data, "Content")}
        {!isEmpty(relatedSymbolList) && (
          <div className="relation-symbol">
            <div className="title-border">関連銘柄</div>
            {map(relatedSymbolList, (data: object) => {
              return (
                <span
                  className="btn btn-primary btn-shaped btn-news"
                  onClick={() =>
                    open_symbol_detail({
                      Symbol: get(data, "Symbol"),
                      Exchange: get(data, "Exchange"),
                      SecurityType: get(data, "SecurityType"),
                    })
                  }
                >
                  {get(data, "SymbolNameS")}
                </span>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export const NewsList = ({
  title = "関連ニュース",
  symbol,
  ...props
}: Props) => {
  const [result, changeResult] = useState({})
  const [currentPage, changePage] = useState(0)
  const [modalData, setModalData] = useState({})
  const [refreshFlag, setRefreshFlag] = useState(false)
  const loadResistId = useMemo(() => uuid(), [])

  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  // @ts-ignore
  const query: object = newsQueryString(get(props, "route"))

  const setNews = async () => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    let param = { WithDetail: true, DayCount: 10, _take: 10 }
    if (symbol) {
      merge(param, query, { Symbol: symbol })
    } else {
      merge(param, query)
    }
    const news: APIResponse.Res | {} = await APIs.News.News(param)
    changeResult(news)
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  useEffect(() => {
    setNews()
  }, [symbol, props.route])

  useEffect(() => {
    if (props.effect) {
      setNews()
      props.setEffect(false)
    }
  }, [props.effect])

  useEffect(() => {
    if (refreshFlag) {
      setNews()
      setRefreshFlag(false)
    }
  }, [refreshFlag])

  useEffect(() => {
    isPageLoading && setNews()
  }, [isPageLoading])

  const refresh = !props.hiddenRefresh ? () => setRefreshFlag(true) : null

  return (
    <Panel
      title={title}
      className={ClassNames("panel-news-list", { tab: props.tabItem })}
      delete={props.delete}
      // refresh={refresh}
      filter={
        props.tabItem && (
          <Tab
            className="tab-panel"
            list={props.tabItem.tabList}
            active={props.tabItem.activeTab}
            onChange={(num: number) => {
              props.tabItem.changeTab(num)
            }}
          />
        )
      }
    >
      <NewsListContents
        className="news-list"
        list={get(result, "ResultList", [])}
        page={PAGE_NUM.PAGE_5}
        current={currentPage}
        openModal={(data: object) => {
          setModalData(data)
        }}
      />
      <Pagination
        list={get(result, "ResultList", [])}
        current={currentPage}
        page={PAGE_NUM.PAGE_5}
        changePage={changePage}
      />
      <NewsModal
        show={!!size(modalData)}
        onHide={() => setModalData({})}
        data={modalData}
      />
    </Panel>
  )
}

export const TopNews = (props: Props) => {
  return (
    <Panel
      title="トップニュース"
      className="panel-news-summary"
      delete={props.delete}
    >
      <div className="summary-news-list">
        <div className="summary-primary-news">
          <div className="summary-news-img news1" />
          <div className="summary-news-title-row">
            <div className="summary-news-title">
              <i className="material-icons" />
              米株、連日の大幅安 トランプ氏の対中関税発表を嫌気
            </div>
            <div className="time-col">08/02 06:17</div>
          </div>
        </div>
      </div>
      <ul className="summary-news-list summary-nest-news-list">
        <li>
          <div className="summary-news-img news2" />
          <div className="summary-news-title-row">
            <div className="summary-news-title">
              ドルが対円で下落、米大統領が対中追加関税を発表＝ＮＹ市場
            </div>
            <div className="time-col">08/02 06:17</div>
          </div>
        </li>
        <li>
          <div className="summary-news-img news3" />
          <div className="summary-news-title-row">
            <div className="summary-news-title">
              米、中国が通商合意するまで「課税」 株安懸念せず＝トランプ氏
            </div>
            <div className="time-col">08/02 06:03</div>
          </div>
        </li>
        <li>
          <div className="summary-news-img  news4" />
          <div className="summary-news-title-row">
            <div className="summary-news-title">
              北朝鮮、新たな飛翔体発射か＝米当局者
            </div>
            <div className="time-col">08/02 05:38</div>
          </div>
        </li>
        <li>
          <div className="summary-news-img news5" />
          <div className="summary-news-title-row">
            <div className="summary-news-title">
              ベゾス氏、アマゾン株18億ドル売却 世界長者番付トップ維持
            </div>
            <div className="time-col">08/02 05:30</div>
          </div>
        </li>
      </ul>
    </Panel>
  )
}

export const NewsPanel = (props: Props) => {
  const newsQuantity = useMemo(
    () => [
      { id: 0, name: "20件", value: 20 },
      { id: 1, name: "50件", value: 50 },
      { id: 2, name: "100件", value: 100 },
      { id: 3, name: "150件", value: 150 },
    ],
    []
  )
  const loadResistId = useMemo(() => uuid(), [])

  const [result, changeResult] = useState({})
  const [currentPage, changePage] = useState(0)
  const [modalData, setModalData] = useState({})
  const [searchKeyword, changeKeyword] = useState<string>("")
  const [active, changeActive] = useState<number>(0)
  const [apiFlag, setApiFlag] = useState(true)
  const [textColor, changeTextColor] = useState("")
  const [newsValue, setNewsValue] = useState(newsQuantity[1].id)
  const [resetFlag, setResetFlag] = useState(false)
  const [newsCategory, setNewsCategory] = useState<{ [key: string]: string }>(
    {}
  )

  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const popover = (
    <Popover id="popover-basic">
      <Popover.Content>
        <div
          className="change-color-circle circle-white"
          onClick={() => changeTextColor("white")}
        />
        <div
          className="change-color-circle circle-ivory"
          onClick={() => changeTextColor("ivory")}
        />
        <div
          className="change-color-circle circle-cream"
          onClick={() => changeTextColor("cream")}
        />
        <div
          className="change-color-circle circle-yellow"
          onClick={() => changeTextColor("yellow")}
        />
        <div
          className="change-color-circle circle-gray"
          onClick={() => changeTextColor("gray")}
        />
        <div
          className="change-color-circle circle-navy"
          onClick={() => changeTextColor("navy")}
        />
        <div
          className="change-color-circle circle-black"
          onClick={() => changeTextColor("black")}
        />
      </Popover.Content>
    </Popover>
  )

  const getAllNews = async () => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    const news: APIResponse.Res | {} = await APIs.News.News({
      WithDetail: true,
      DayCount: 10,
      _take: get(find(newsQuantity, { id: newsValue }), "value"),
      _skip: currentPage * newsQuantity[newsValue].value,
    })
    changeResult(news)
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  const getSelectNews = async (symbol?: string) => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    let _where: string = null
    forEach(newsCategory, (Category, key) => {
      forEach(Category, items => {
        if (!_where) {
          _where = `${key}="${items}"`
        } else {
          _where += ` OR ${key}="${items}"`
        }
      })
    })
    const params = {
      _where: _where,
      WithDetail: true,
      DayCount: 10,
      _take: get(find(newsQuantity, { id: newsValue }), "value"),
      _skip: currentPage * newsQuantity[newsValue].value,
    }
    if (!isEmpty(symbol)) {
      merge(params, { Symbol: symbol, DayCount: 90 })
    }
    const news: APIResponse.Res | {} = await APIs.News.News(params)
    changeResult(news)
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  useEffect(() => {
    if (!apiFlag) return
    getAllNews()
  }, [])

  useEffect(() => {
    isPageLoading && getSelectNews(searchKeyword)
  }, [isPageLoading])

  useEffect(() => {
    if (!apiFlag || isEmpty(result)) return
    getSelectNews(searchKeyword)
    changePage(0)
  }, [newsCategory])

  useEffect(() => {
    if (isEmpty(searchKeyword)) return
    getSelectNews(searchKeyword)
  }, [searchKeyword])

  useEffect(() => {
    if (isEmpty(result)) return
    getSelectNews(searchKeyword)
  }, [currentPage])

  useEffect(() => {
    if (isEmpty(result)) return
    if (currentPage === 0) {
      getSelectNews(searchKeyword)
    } else {
      changePage(0)
    }
  }, [newsValue])

  useEffect(() => {
    if (resetFlag) {
      if (!isEmpty(searchKeyword)) {
        changeKeyword("")
      }
      setResetFlag(false)
    }
  }, [resetFlag])

  return (
    <Panel
      title=""
      delete={props.delete}
      className="panel-news-collapse"
      // refresh={() => {
      //   if (apiFlag) {
      //     getSelectNews()
      //   } else {
      //     getAllNews()
      //   }
      // }}
      filter={
        <div className="filter-col">
          <div className="row-filter">
            <SearchDetail
              className="search-bar"
              placeholder={searchKeyword || "銘柄コード/銘柄名"}
              executeFunction={(obj: APIResponse.Res) => {
                changeKeyword(get(obj, "Symbol"))
                changePage(0)
                changeActive(0)
              }}
              selectNewsAll={isEmpty(newsCategory)}
              hasCountryBtn={true}
              forceActive={true}
              isDirect={true}
              collectively={true}
              clearButton={true}
              setResetFlag={setResetFlag}
              inputId="search-news-header"
              isSearchNews={!!searchKeyword}
            />
            <OverlayTrigger trigger="click" placement="right" overlay={popover}>
              <i
                className="material-icons ripple change-color-icon"
                title={"文字色変更"}
              >
                brush
              </i>
            </OverlayTrigger>
            <BaseSelect
              option={newsQuantity}
              value={newsValue}
              onChange={setNewsValue}
            />
          </div>
        </div>
      }
    >
      <div className="toggle-col">
        <div className="collapse-news">
          <ToggleFilter
            setCategory={setNewsCategory}
            setApiFlag={setApiFlag}
            resetFlag={resetFlag}
          />
        </div>
        <div className="result-news-list">
          <div className="news-title-list" id="target">
            {isEmpty(get(result, "ResultList", [])) ? (
              <div className="news-empty">
                <span>フィルター設定に該当するニュースはありません</span>
              </div>
            ) : (
              <NewsListContents
                className="news-list"
                list={get(result, "ResultList", [])}
                page={newsQuantity[newsValue].value}
                current={currentPage}
                openModal={(data: object) => setModalData(data)}
                isNewsTab={!!props.isNewsTab}
                active={active}
                changeActive={changeActive}
                acquiredSeparatelyFlag={true}
              />
            )}
          </div>
          <NewsDetailContents
            data={modalData}
            textColor={textColor}
            list={get(result, "ResultList", [])}
          />
          <Pagination
            total={get(result, "TotalCount", [])}
            list={get(result, "ResultList", [{}])}
            current={currentPage}
            page={newsQuantity[newsValue].value}
            changePage={(num: number) => {
              const target = document.getElementById("target")
              changePage(num)
              changeActive(0)
              target.scrollTo(0, 0)
            }}
          />
        </div>
      </div>
    </Panel>
  )
}

const TAKE_NUM = 50

export const SpNewsPanel = () => {
  const [result, setResult] = useState<Array<APIResponse.Res | null>>([])
  const [modalData, setModalData] = useState({})
  const [filterVisible, setFilterVisible] = useState(false)
  const [newsCategory, setNewsCategory] = useState<{ [key: string]: string }>(
    {}
  )
  const [apiTrigger, setApiTrigger] = useState(false)
  const [totalCount, setToalCount] = useState(null)
  const [selectedNewsCategory, setSelectedNewsCategory] = useState(
    map(NEWS_TOGGLE, items => {
      return items.id
    })
  )

  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const allFlag = useMemo(() => {
    return includes(selectedNewsCategory, NEWS_TOGGLE[0].id)
  }, [selectedNewsCategory])
  const loadResistId = useMemo(() => uuid(), [])

  const _setSelectedNewsCategory = useCallback(
    (id: number) => {
      let _selectedNewsCategory = clone(selectedNewsCategory)
      if (id === 0) {
        if (includes(_selectedNewsCategory, 0)) {
          _selectedNewsCategory = []
        } else {
          _selectedNewsCategory = map(NEWS_TOGGLE, items => {
            return items.id
          })
        }
      } else {
        pull(_selectedNewsCategory, 0)
        if (includes(_selectedNewsCategory, id)) {
          pull(_selectedNewsCategory, id)
        } else {
          _selectedNewsCategory.push(id)
        }
      }
      setSelectedNewsCategory(_selectedNewsCategory)
    },
    [selectedNewsCategory]
  )

  useEffect(() => {
    let apiParam = {}
    if (selectedNewsCategory.length !== NEWS_TOGGLE.length) {
      forEach(selectedNewsCategory, id => {
        if (id === 1 || id === 2) {
          const _source = get(apiParam, "Source", [])
          _source.push(NEWS_TOGGLE[id].key)
          apiParam = merge(apiParam, { Source: _source })
        } else if (id !== 0) {
          const _category = get(apiParam, "Category", [])
          _category.push(NEWS_TOGGLE[id].key)
          apiParam = merge(apiParam, { Category: _category })
        }
      })
    }
    setNewsCategory(apiParam)
  }, [selectedNewsCategory])

  const getSelectNews = async () => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    let whereparam: string = null
    let apiParam = {
      WithDetail: true,
      DayCount: 10,
      _take: TAKE_NUM,
      _skip: result.length,
    }
    forEach(newsCategory, (Category, key) => {
      forEach(Category, items => {
        if (!whereparam) {
          whereparam = `${key}="${items}"`
        } else {
          whereparam += ` OR ${key}="${items}"`
        }
      })
    })

    const news: APIResponse.Res | {} = await APIs.News.News(
      !allFlag ? merge(apiParam, { _where: whereparam }) : apiParam
    )
    const _result = get(news, "ResultList", [])
    setResult([...result, ..._result])
    setToalCount(get(news, "TotalCount", 0))
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  useEffectFirstSkip(getSelectNews, [newsCategory])

  useEffect(() => {
    if (!apiTrigger || totalCount <= result.length) return
    setApiTrigger(false)
    getSelectNews()
  }, [apiTrigger])

  useEffect(() => {
    if (!isPageLoading) return
    getSelectNews()
  }, [isPageLoading])

  return (
    <Panel title="" className="panel-sp-news-collapse" nonePanelHeader={true}>
      <div className="sp-news-menu-btn">
        <i
          className="material-icons"
          onClick={() => setFilterVisible(!filterVisible)}
        >
          more_vert
        </i>
      </div>
      {filterVisible && (
        <>
          <div
            className="close-trigger"
            onClick={() => setFilterVisible(false)}
          />
          <div className="collapse-news">
            <SpToggleFilter
              isVisible={filterVisible}
              setVisible={setFilterVisible}
              selectedNewsCategory={selectedNewsCategory}
              setSelectedNewsCategory={_setSelectedNewsCategory}
            />
          </div>
        </>
      )}
      <div
        className={ClassNames("result-news-list", {
          menuActive: filterVisible,
        })}
      >
        <div className="news-title-list" id="target">
          {isEmpty(result) ? (
            <div className="news-empty">
              <span>フィルター設定に該当するニュースはありません</span>
            </div>
          ) : (
            <SpNewsListContents
              className="sp-news-list"
              lists={result}
              openModal={(data: object) => setModalData(data)}
              func={() => setApiTrigger(true)}
              btnDisable={totalCount <= result.length}
            />
          )}
        </div>
        {/* <Pagination
            list={get(result, "ResultList", [{}])}
            current={currentPage}
            page={PAGE_NUM.PAGE_20}
            changePage={(num: number) => {
              const currentDataList = chunkData[num][0]
              const target = document.getElementById("target")
              changePage(num)
              changeActive(0)
              setModalData(currentDataList)
              target.scrollTo(0, 0)
            }}
          /> */}
        <NewsModal
          show={!!size(modalData)}
          onHide={() => setModalData({})}
          data={modalData}
        />
      </div>
    </Panel>
  )
}

export const SymbolDetailModalNewsPanel = (props: { symbolCode: string }) => {
  const [result, setResult] = useState<Array<APIResponse.Res | null>>([])
  const [totalCount, setTotalCount] = useState(0)
  const [page, setPage] = useState<number>(0)
  const [active, changeActive] = useState<number>(0)
  const loadingId = useMemo(() => uuid(), [])

  useEffect(() => {
    if (isNil(props.symbolCode)) return
    ;(async () => {
      store.dispatch(pageLoadRegist(loadingId, true))
      const news: APIResponse.Res | {} = await APIs.News.News({
        WithDetail: true,
        DayCount: 90,
        Symbol: props.symbolCode,
        _take: PAGE_NUM.PAGE_5,
        _skip: page * PAGE_NUM.PAGE_5,
      })
      if (!!get(news, "isAxiosError")) {
        setResult([])
        setTotalCount(0)
      } else {
        setResult(get(news, "ResultList", []))
        setTotalCount(get(news, "TotalCount", 0))
      }
      store.dispatch(pageLoadRegist(loadingId, false))
    })()
  }, [props.symbolCode, page])

  const _changeActive = (id: number) => {
    changeActive(id)
  }

  useEffect(() => {
    _changeActive(0)
  }, [result])

  return (
    <Panel
      title=""
      className="panel-symbol-detail-news-collapse"
      nonePanelHeader={true}
    >
      <div className="symbol-detail-news-contents">
        <div className="news-title-list" id="target">
          {isEmpty(result) ? (
            <div className="news-empty">
              <span>該当するニュースはありません</span>
            </div>
          ) : (
            <>
              <SymbolDetailMoalNewsListContents
                className="news-list"
                list={result}
                active={active}
                changeActive={_changeActive}
              />
              <Pagination
                total={totalCount}
                list={result}
                current={page}
                page={PAGE_NUM.PAGE_5}
                changePage={(num: number) => setPage(num)}
              />
            </>
          )}
        </div>
      </div>
    </Panel>
  )
}
